import EDAvatar from '../../BaseComponents/Avatar/EDAvatar';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EDBox from '../../BaseComponents/EDBox/EDBox';

interface IProps {
  leftMargin?: boolean;
  textboxMarker?: boolean;
  shape?: 'circle' | 'datagridBorder' | 'outlineBorder';
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      root: {
        background: theme.palette.primary.light,
        borderRadius: '50%',
        width: 15,
        height: 15,
      },
      marginLeft: {
        marginLeft: theme.spacing(1),
      },
      textboxMarker: {
        width: 6,
        height: 30,
        borderTopLeftRadius: 3,
        borderBottomLeftRadius: 3,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
    } as const)
);

/**
 * En ikon som markerar att en ändring har skett
 */
const ChangedMarker = (props: IProps) => {
  const {
    classes: { root, marginLeft, textboxMarker },
    cx,
  } = useStyles();
  return (
    <EDAvatar
      className={cx(root, {
        [marginLeft]: props.leftMargin,
        [textboxMarker]: props.textboxMarker,
      })}
      data-testid="ChangedMarker"
    >
      <div />
    </EDAvatar>
  );
};

export const ChangedMarkerLine = (props: IProps) => (
  <EDBox
    sx={[
      theme => ({
        background: theme.customProperties.extralightPrimary,
        position: 'absolute',
        top: props.shape === 'outlineBorder' ? '1px' : 0,
        bottom: props.shape === 'outlineBorder' ? '1px' : 0,
        left: props.shape === 'outlineBorder' ? '1px' : 0,
        width: '3px',
      }),
      props.shape === 'outlineBorder' && {
        borderTopLeftRadius: '3px',
        borderBottomLeftRadius: '3px',
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      props.shape === 'datagridBorder' && {
        marginTop: '-1px',
        marginBottom: '-1px',
      },
    ]}
    data-testid="ChangedMarker"
  />
);

export default ChangedMarker;
